import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Root } from './DeptTeam.css';
import PageTitle from '../Layout/components/PageTitle';
import { Dialog } from '@material-ui/core';
import TeamInfo from './components/TeamInfo';
import DeptInfo from './components/DeptInfo'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog';
import { ADD, EDIT, VIEW } from '../../common/common';
import { deduplicationObjArr } from '../../common/utils';
import FoldTable from '../Components/FoldTable';
import userDao from '../../request/userDao';

class DeptTeam extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            openDept: false,
            openTeam: false,
            dialogState: ADD,
            dialogTitle: "",
            currentObj: null,
            teams: [],
            deptData: [],
            officeData: [],

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false
        }
        this.handleCloseDialog = this.handleCloseDialog.bind(this);

        this.handleAddTeam = this.handleAddTeam.bind(this);
        this.handleDeptView = this.handleDeptView.bind(this);
        this.handleDeptEdit = this.handleDeptEdit.bind(this);
        this.handleDeptDel = this.handleDeptDel.bind(this);
        this.handleTeamView = this.handleTeamView.bind(this);
        this.handleTeamEdit = this.handleTeamEdit.bind(this);
        this.handleTeamDel = this.handleTeamDel.bind(this);

        this.handleEditDept = this.handleEditDept.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleTeamCancel = this.handleTeamCancel.bind(this);
        this.createTeams = this.createTeams.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            openDept,
            openTeam,
            deptData,
            dialogTitle,
            dialogState,
            currentObj,
            officeData,
            showToast,
            toastMsg,
            toastState,
            showAlert,
        } = this.state;
        return (
            <Root>
                <div className="head h">
                    <PageTitle title="TEAM" subtitle="MANAGEMENT"></PageTitle>
                </div>
                <FoldTable
                    deptsData={deptData}
                    handleAddTeam={this.handleAddTeam}
                    handleDeptView={this.handleDeptView}
                    handleDeptEdit={this.handleDeptEdit}
                    handleDeptDel={this.handleDeptDel}
                    handleTeamView={this.handleTeamView}
                    handleTeamEdit={this.handleTeamEdit}
                    handleTeamDel={this.handleTeamDel}
                />
                <Dialog maxWidth={false} open={openDept}>
                    <DeptInfo
                        handleCreate={this.handleEditDept}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={currentObj}
                        state={dialogState}
                        officeData={officeData}
                    ></DeptInfo>
                </Dialog>
                <Dialog maxWidth={false} open={openTeam}>
                    <TeamInfo
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleTeamCancel}
                        title={dialogTitle}
                        data={currentObj}
                        state={dialogState}
                    ></TeamInfo>
                </Dialog>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this team?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.initData();
    }

    initData() {
        this.getAllDepts((allDepts) => {
            userDao.getUserInfo((userData) => {
                const userTeams = this.extMyDeptOrTeam(userData.roles, "team");
                const userDepts = this.extractDepts(userTeams);
                const teams = this.mergeTeams(allDepts, userDepts, userTeams);

                const myDepts = this.extMyDeptOrTeam(userData.roles, "dept");
                const depts = this.mergeDepts(allDepts, myDepts);
                console.log("================")
                console.log("depts", depts)
                console.log("================")
                const sourceDeptData = depts.concat(teams);
                const deptData = this.filterTeamByRole(sourceDeptData);
                //过滤出相同的team 并检查权限
                this.setState(() => ({
                    deptData
                }));
            });
        });
    }
    // id: 2, name: "dept_manager"
    // id: 3, name: "team_leader"
    // id: 6, name: "staff"
    filterTeamByRole(deptData) {
        //筛选出相同的team
        let delArr = [];
        deptData.forEach(function (value, index) {
            let obj = [];
            for (let i = 0; i < delArr.length; i++) {
                // 对比相同的字段key，相同放入对应的数组
                if (delArr[i][0].id === value.id) {
                    delArr[i].push(value);
                    return;
                }
            }
            obj.push(value);
            delArr.push(obj);
        });
        //移除权限最高的一个 剩下的属于需要删掉的
        for (let i = delArr.length - 1; i >= 0; i--) {
            const arr = delArr[i];
            if (arr.length > 1) {
                arr.sort(this.compare("role", "id"));
                arr.splice(0, 1);
                console.log(arr)
            } else {
                delArr.splice(i, 1);
            }
        }
        //根据delarr 删除deptData中权限低的team
        if (delArr.length > 0) {
            for (const arr of delArr) {
                for (const obj of arr) {
                    for (let i = deptData.length - 1; i >= 0; i--) {
                        const obj2 = deptData[i];
                        if (obj.id === obj2.id && obj.role.id === obj2.role.id) {
                            deptData.splice(i, 1);
                        }
                    }
                }
            }
        }
        return deptData;
    }
    //对象数组排序 权限最高的排前面
    compare(key1, key2) {
        return function (value1, value2) {
            var val1 = value1[key1][key2];
            var val2 = value2[key1][key2];
            return val1 - val2;
        }
    }
    mergeDepts(allDepts, userDepts) {
        let deptData = [];
        for (const userObj of userDepts) {
            for (const allObj of allDepts) {
                if (userObj.dept.id === allObj.id) {
                    let newObj = this.clone(allObj);
                    newObj.expanded = false;
                    newObj.role = userObj.role;
                    let teams = newObj.teams;
                    if (teams.length > 0) {
                        for (const obj of teams) {
                            obj.role = userObj.role;
                        }
                    }
                    deptData.push(newObj);
                }
            }
        }
        return deptData;
    }
    extMyDeptOrTeam(rolesObj, type) {
        let teamArr = [];
        for (const obj of rolesObj) {
            const deptObj = obj.department;
            const teamObj = obj.team;
            const roleObj = obj.role;
            let newObj = {};
            if (deptObj && type === "dept") {
                newObj.dept = deptObj;
                newObj.role = roleObj;
                teamArr.push(newObj);
            } else if (teamObj && type === "team") {
                newObj = teamObj;
                newObj.role = roleObj;
                teamArr.push(newObj);
            }
        }
        return teamArr;
    }
    extractDepts(userTeams) {
        let userDepts = [];
        if (userTeams) {
            for (const obj of userTeams) {
                let newObj = {};
                newObj.dept = obj.dept;
                newObj.role = obj.role;
                userDepts.push(newObj);
            }
            // const newUserDepts = deduplicationObjArr(userDepts, "dept", "id");
            return userDepts;
        } else {
            return [];
        }
    }
    mergeTeams(allDepts, userDepts, userTeams) {
        let deptData = [];
        for (const userObj of userDepts) {
            for (const allObj of allDepts) {
                if (userObj.dept.id === allObj.id) {
                    let newObj = this.clone(allObj);
                    newObj.expanded = false;
                    newObj.role = userObj.role;
                    deptData.push(newObj);
                }
            }
        }
        //过滤该账号所在的dept下不属于该账号的team
        const filterDepts = this.filterOtherTeam(deptData, userTeams);
        const officeData = deduplicationObjArr(allDepts, "office");
        this.setState(() => ({
            // TeamData: filterDepts,
            officeData
        }));
        return filterDepts
    }
    filterOtherTeam(deptData, userTeams) {
        const myDept = this.formatUserTeam(deptData, userTeams);
        let newDept = [];
        for (const deptObj of deptData) {
            let newObj = this.clone(deptObj);
            newObj.teams = [];
            for (const myDeptObj of myDept) {
                if (deptObj.id === myDeptObj.id) {
                    let myDeptTeams = myDeptObj.teams;
                    let deptTeams = deptObj.teams;
                    for (const myDeptTeamObj of myDeptTeams) {
                        for (const deptTeamObj of deptTeams) {
                            if (myDeptTeamObj.id === deptTeamObj.id) {
                                let newTeamObj = this.clone(deptTeamObj);
                                newTeamObj.role = myDeptTeamObj.role;
                                newObj.teams.push(newTeamObj);
                            }
                        }
                    }
                }
            }
            newDept.push(newObj);
        }
        const filterDepts = deduplicationObjArr(newDept, "id");
        return filterDepts;
    }
    formatUserTeam(deptData, userTeams) {
        let newArr = [];
        for (const deptObj of deptData) {
            let newObj = {};
            newObj.id = deptObj.id;
            newObj.teams = [];
            for (const myDeptObj of userTeams) {
                if (deptObj.id === myDeptObj.dept.id) {
                    let obj = {};
                    obj.id = myDeptObj.id;
                    newObj.teams.push(myDeptObj)
                }
            }
            newArr.push(newObj);
        }
        const myDept = deduplicationObjArr(newArr, "id");
        return myDept;
    }
    clone(origin) {
        return JSON.parse(JSON.stringify(origin))
    }
    handleDeptView(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDeptDialog(obj.name + " INFO", VIEW);
    }
    handleDeptEdit(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openDeptDialog("EDIT " + obj.name + " INFO", EDIT);
    }
    handleDeptDel(obj) {
        this.setState(() => ({
            currentObj: obj,
            showAlert: true
        }));
    }
    handleAddTeam(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openTeamDialog("ADD TEAM", ADD);
    }
    handleTeamView(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openTeamDialog(obj.name + " TEAM INFO", VIEW);
    }
    handleTeamEdit(obj) {
        this.setState(() => ({
            currentObj: obj
        }))
        this.openTeamDialog("EDIT " + obj.name + " TEAM INFO", EDIT);
    }
    handleTeamDel(obj) {
        this.setState(() => ({
            currentObj: obj,
            showAlert: true
        }));
    }
    //关闭dialog
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCreate(obj, members) {
        const { dialogState, currentObj } = this.state;
        if (dialogState === ADD) {
            //添加team时是没有teamId的 所以要先创建team后得到teamId再进行成员添加
            const dept_id = currentObj.id;
            this.createTeams(dept_id, obj, members);
        } else if (dialogState === EDIT) {
            let team_id = currentObj.id;
            let params = {};
            if (currentObj.name === obj.name) {
                params = {
                    description: obj.description,
                }
            } else {
                params = {
                    name: obj.name,
                    description: obj.description,
                }
            }
            this.updateTeams(team_id, params);
        }
    }
    handleEditDept(dept_id, description) {
        this.updateDept(dept_id, description);
    }
    //取消dialog
    handleCancel() {
        this.closeDialog();
    }
    handleTeamCancel() {
        this.initData();
        this.closeDialog();
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        this.delTeam(this.state.currentObj.id);
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            openDept: false,
            openTeam: false,
            currentObj: null,
        }));
    }
    openDeptDialog(title, state) {
        this.setState(() => ({
            openDept: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    openTeamDialog(title, state) {
        this.setState(() => ({
            openTeam: true,
            dialogTitle: title,
            dialogState: state
        }));
    }
    //-----------request-------------
    getAllDepts(callback = null) {
        let params = {
            page_index: 1,
            page_size: 1000
        }
        instance.get(BASE_URL + 'common/departments', { params }).then((res) => {
            const allDepts = res.data.data;
            callback(allDepts);
        })
    }
    getTeams(callback = null) {
        instance.get(BASE_URL + 'department/teams').then((res) => {
            const teams = res.data.data;
            this.setState({
                teams
            }, () => {
                if (callback) callback(teams);
            });
        })
    }
    updateDept(dept_id, description) {
        let params = {
            description
        }
        instance.put(BASE_URL + "department/departments/" + dept_id, params).then((res) => {
            console.log("editTeam", res);
            this.initData();
            this.showToast("Successfully modified", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    createTeams(dept_id, teamObj, members) {
        console.log("members", members)
        let params = {
            dept_id,
            name: teamObj.name,
            description: teamObj.description,
            members,
        }
        console.log("params", params)
        instance.post(BASE_URL + 'department/teams', params).then((res) => {
            this.initData();
            this.showToast("Added successfully", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    updateTeams(team_id, params) {
        instance.put(BASE_URL + "department/teams/" + team_id, params).then((res) => {
            console.log("editTeam", res);
            this.initData();
            this.showToast("Successfully modified", "success");
            this.closeDialog();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delTeam(team_id) {
        instance.delete(BASE_URL + "department/teams/" + team_id).then((res) => {
            console.log("deletteam", res);
            this.initData();
            this.showToast("Successfully deleted", "success");
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    //members(array)   结构[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    addTeamMembers(team_id, members, callback) {
        let params = {
            members
        }
        instance.post(BASE_URL + "department/teams/" + team_id + "/members", params).then((res) => {
            this.showToast("Added successfully", "success");
            console.log("addteam", res);
            callback()
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    //members(array)   结构[ {user_id:**,  role_id:**}, {user_id:**,  role_id:**}]
    delTeamMembers(team_id, members) {
        let params = {
            members
        }
        instance.delete(BASE_URL + "department/teams/" + team_id + "/members", { data: params }).then((res) => {
            this.showToast("Successfully deleted", "success");
            console.log("delMembers", res);
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

export default withRouter(DeptTeam);